import React from "react";
import { changepassword } from "../../../../../common/lib/changepassword";
import { encryptData } from "../../../../lib/crypto/crypto";
import CustomCarousel from "../../../carousel/theme11/CustomCarousel";
import { noLeadingSpace } from "../../../../lib/utils/regex_cheat_sheet";
class ResetPassword extends React.Component {
  getGeneralError(password, confirmPassword) {
    if (!confirmPassword) return "";
    if (confirmPassword !== password) return "Passwords do not match.";
    return "";
  }
  constructor(props) {
    super(props);
    this.state = {
      password: "",
      confirmPassword: "",
      passwordError: "",
      errorMessage: "", // unified error state
      showPassword: false,
      showConfirmPassword: false,
      passwordRulesStatus: {
        length: false,
        uppercase: false,
        number: false,
        special: false,
        noSpace: false,
      },
    };
  }

  togglePassword = () => {
    this.setState((prevState) => ({ showPassword: !prevState.showPassword }));
  };

  toggleConfirmPassword = () => {
    this.setState((prevState) => ({
      showConfirmPassword: !prevState.showConfirmPassword,
    }));
  };

  handleChangePassword = (e) => {
    if (!noLeadingSpace.test(e.target.value) && e.target.value !== "") {
      return;
    }
    const value = e.target.value;
    const confirmError = this.getGeneralError(
      value,
      this.state.confirmPassword
    );
    this.setState({
      password: value,
      passwordError: this.getPasswordErrorMessage(value),
      passwordRulesStatus: this.getPasswordRulesStatus(value),
      errorMessage: confirmError,
    });
  };

  handleChangeConfirmPassword = (e) => {
    if (!noLeadingSpace.test(e.target.value) && e.target.value !== "") {
      return;
    }
    const value = e.target.value;
    const confirmError = this.getGeneralError(this.state.password, value);
    this.setState({
      confirmPassword: value,
      errorMessage: confirmError,
    });
  };

  getPasswordErrorMessage(password) {
    if (!password) return "Password is required.";
    if (password.length < 8 || password.length > 20)
      return "Password must be between 8 and 20 characters.";
    if (!/[A-Z]/.test(password))
      return "Password must contain at least one uppercase letter.";
    if (!/[0-9]/.test(password))
      return "Password must contain at least one number.";
    if (!/[!@#$%^&*(),.?":{}|<>]/.test(password))
      return "Password must contain at least one special character.";
    if (password.includes(" ")) return "Spaces are not allowed in password.";
    return "";
  }

  getConfirmPasswordErrorMessage(confirmPassword) {
    if (!confirmPassword) return "Please re-enter your password.";
    if (confirmPassword !== this.state.password)
      return "Passwords do not match.";
    return "";
  }

  handleSubmit = async (e) => {
    e.preventDefault();

    const { popupType: type } = this.props; 

    const passwordError = this.getPasswordErrorMessage(this.state.password);
    const confirmError = this.getGeneralError(
      this.state.password,
      this.state.confirmPassword
    );
    if (passwordError || confirmError) {
      this.setState({ passwordError, errorMessage: confirmError });
      return;
    }

    this.setState({ onClickLoginLoader: true, errorMessage: "" });

    const resettoken =
      this.props.router?.query?.resettoken ||
      this.props.router?.query?.createtoken;

    const changePassReq = {
      confirm_password: encryptData(this.state.confirmPassword),
      new_password: encryptData(this.state.password),
      resettoken,
      crypto: true,
    };

    try {
      const res = await changepassword(changePassReq);

      if (res && res.status) {
        if (
          this.props.handlers &&
          typeof this.props.handlers.setPopupType === "function"
        ) {
          this.props.handlers.setPopupType(
            type === "resettokenExpiry"
              ? { popupPage: "createConfirmed" }
              : { popupPage: "PasswordResetConfirmed" }
          );

          this.setState({
            errorMessage: "",
            onClickLoginLoader: false,
          });
        }
      } else {
        this.setState({
          errorMessage:
            res && res.message ? res.message : "Password reset failed.",
          onClickLoginLoader: false,
        });
      }
    } catch (error) {
      this.setState({
        errorMessage:
          error && error.message ? error.message : "Password reset failed.",
        onClickLoginLoader: false,
      });
    }
  };

  getPasswordRulesStatus(password) {
    return {
      length: password.length >= 8 && password.length <= 20,
      uppercase: /[A-Z]/.test(password),
      number: /[0-9]/.test(password),
      special: /[!@#$%^&*(),.?":{}|<>]/.test(password),
      noSpace: password.length > 0 && !password.includes(" "),
    };
  }

  render() {
    const { styles, isMobile } = this.props;
    const {
      password,
      confirmPassword,
      passwordError,
      errorMessage,
      showPassword,
      showConfirmPassword,
      passwordRulesStatus = {},
    } = this.state;
    const alertErrorClass = styles.figma_alert_error || styles.error_alert;
    const alertSuccessClass =
      styles.figma_alert_success || styles.success_alert;
    const isPasswordValid =
      !this.getPasswordErrorMessage(password) && password.length > 0;
    const isConfirmValid =
      !this.getConfirmPasswordErrorMessage(confirmPassword) &&
      confirmPassword.length > 0;
    // Array for password rules
    const passwordRules = [
      {
        key: "length",
        label: "Between 8 to 20 characters",
      },
      {
        key: "uppercase",
        label: "One uppercase letter",
      },
      {
        key: "number",
        label: "One or more numbers",
      },
      {
        key: "special",
        label: "One or more special characters",
      },
      {
        key: "noSpace",
        label: "No spaces allowed",
      },
    ];
  const isButtonDisabled = !Object.values(passwordRulesStatus).every(Boolean);

    const imageLoader = ({ src }) => {
      const url = `/shared/api/media/${src}`;
      return url;
    };
    const banners = this.props?.siteData?.data?.signin?.banners;
    const PromotionBannerCss = this.props.PromotionBannerCss;
    const customResponsive = {
      desktop: { breakpoint: { max: 3000, min: 1024 }, items: 1 },
      tablet: {
        breakpoint: { max: 1024, min: 464 },
        items: 2,
        slidesToSlide: 2,
      },
      mobile: { breakpoint: { max: 464, min: 0 }, items: 1, slidesToSlide: 1 },
    };
    const type = this.props?.popupType || {};
    return (
      <div className={styles.main_content}>
        {/* Left side - Promotional Banner */}
        <div className={styles.login_banner}>
          <CustomCarousel
            banners={banners}
            imageLoader={imageLoader}
            cssstyles={PromotionBannerCss}
            arrows={false}
            dots={true}
            autoplay={false}
            imageKey="upload_image"
            prevArrow={"/images/back-arrow.png"}
            nextArrow={"/images/back-arrow.png"}
            responsive={customResponsive}
          />
          {isMobile ? (
            <div className={styles.banner_left_arrrow}>
              <img src="images/te_Left_Arrow.svg" alt="arrow" />
            </div>
          ) : null}
        </div>
        {/* Right side - Reset Password Form */}
        <div className={styles.login_section}>
          <div className={styles.login_form}>
            <div className={styles.form_header}>
              <h3>
                {type === "resettokenExpiry"
                  ? "Create New Password"
                  : "Reset Password"}
              </h3>
              <div className={styles.form_subtitle}>
                <span>Please set a new password for your account.</span>
              </div>

              {errorMessage && (
                <div className={styles.error_message} id="error-message">
                  <div className={styles.error_icon}>
                    <img src="images/te_Invalied.svg" alt="Invalid icon" />
                  </div>
                  <span>{errorMessage}</span>
                </div>
              )}
            </div>

            <form
              className={styles.form_reset_wrap}
              onSubmit={this.handleSubmit}
            >
              <div
                className={`${styles.form_group} ${styles.reset_password_wrap}`}
              >
                <label htmlFor="password">Enter New Password</label>
                <div className={styles.input_container}>
                  <input
                    type={showPassword ? "text" : "password"}
                    id="password"
                    placeholder="Enter New Password"
                    className={`${styles.normal_input} ${passwordError ? styles.input_error : ""
                      }`}
                    value={password}
                    onChange={this.handleChangePassword}
                  />
                  <button
                    className={styles.toggle_password}
                    type="button"
                    onClick={this.togglePassword}
                  >
                    <img
                      src={
                        showPassword
                          ? "images/te_Eye_off.svg"
                          : "images/te_Eye.svg"
                      }
                      alt="Toggle Password"
                    />
                  </button>
                </div>
                {passwordError && (
                  <div className={styles.error_text}>{passwordError}</div>
                )}
              </div>
              <div
                className={`${styles.form_group} ${styles.reset_password_wrap}`}
              >
                <label htmlFor="confirmPassword">Re-enter New Password</label>
                <div className={styles.input_container}>
                  <input
                    type={showConfirmPassword ? "text" : "password"}
                    id="confirmPassword"
                    placeholder="Re-enter New Password"
                    className={`${styles.normal_input} ${errorMessage ? styles.input_error : ""
                      }`}
                    value={confirmPassword}
                    onChange={this.handleChangeConfirmPassword}
                  />
                  <button
                    className={styles.toggle_password}
                    type="button"
                    onClick={this.toggleConfirmPassword}
                  >
                    <img
                      src={
                        showConfirmPassword
                          ? "images/te_Eye_off.svg"
                          : "images/te_Eye.svg"
                      }
                      alt="Toggle Password"
                    />
                  </button>
                </div>
                {/* No separate confirmPasswordError, all errors shown above */}
              </div>
              <button className={`${styles.login_btn}  ${this.state.onClickLoginLoader?'loading':''}`} type="submit" disabled={isButtonDisabled || confirmPassword.length === 0 }>
                <span>Reset Password</span>
                <img src="images/te_Arrow_right.svg" alt="arrow" />
              </button>
            </form>
            {/* Password Rules Section */}
            <div className={styles.register_form_password_info}>
              <p className={styles.register_form_pwd_label}>
                Password must contain at least
              </p>
              <ul className={`${styles.register_form_pwd_list}`}>
                {passwordRules.map((rule) => (
                  <li
                    className={`${passwordRulesStatus[rule.key]
                      ? styles.register_form_green
                      : styles.register_form_red
                      }`}
                  >
                    {" "}
                    {rule.label}
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default ResetPassword;
